<template>
  <div>
    <form @submit="submitSearchForm">
      <div class="form-group">
        <i class="icon_pin_alt" />
        <input
          class="form-control"
          type="text"
          :value="searchAddress"
          disabled
          style="background-color: white"
        >
      </div>

      <div class="form-group margin_bottom_10">
        <input
          id="locker_start_date"
          v-model="inputDate"
          aria-label="Fecha"
          class="form-control"
          type="text"
          readonly
          style="padding-right: 40px; background-color: white"
          autocomplete="off"
          required
          :placeholder="$t('lang.search.dates.input_placeholder')"
          data-toggle="dropdown"
          @click="$bvModal.show('date-modal');"
        >
        <i
          class="icon-calendar"
          @click="$bvModal.show('date-modal');"
        />
      </div>

      <Errors :errors="errors" />
      <input
        type="submit"
        :value="$t('lang.locker_home.search_button')"
      >
    </form>
    <DatePickerModal @datesSelected="updateDates" />
  </div>
</template>

<script>
import DatePickerModal from '@/components/Search/DatePickerModal';
import Errors from '../Alerts/Errors';

export default {
  name: 'LockerSearchForm',

  components: {
    DatePickerModal,
    Errors,
  },

  props: {
    setLocation: {
      type: Object,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      searchAddress: '',
      inputDate: '',
      searchParams: {
        place: null,
        input_start_date: '',
        input_end_date: '',
        bags_number: 1,
      },
      errors: {},
    };
  },

  watch: {
    setLocation() {
      this.setPlace(this.setLocation);
    },
  },

  mounted() {
    if (this.setLocation) {
      this.setPlace(this.setLocation);
    }
  },

  methods: {

    setPlace(place) {
      this.searchParams.place = place;
      this.searchAddress = place.formatted_address;
      this.errors = {};

      try {
        this.$store.dispatch('setSearchParams', this.searchParams);
      } catch (e) {
        this.errors = { data_error: [this.$t('lang.search.place_error')] };
      }
    },

    updateDates(startDate, endDate) {
      const lang = window.navigator.language;
      let input = '';

      const today = new Date().toLocaleString(lang, { day: '2-digit', month: '2-digit' });
      let tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      tomorrow = tomorrow.toLocaleString(lang, { day: '2-digit', month: '2-digit' });

      const start = startDate.toLocaleString(lang, { day: '2-digit', month: '2-digit' });
      const end = endDate.toLocaleString(lang, { day: '2-digit', month: '2-digit' });
      const startHour = startDate.toLocaleString('en-US', { hour: 'numeric', hour12: true });
      const endHour = endDate.toLocaleString('en-US', { hour: 'numeric', hour12: true });

      if (start === end && start === today) {
        input = `${this.$t('lang.search.dates.today')} | ${startHour} → ${endHour}`;
      } else if (start === end && start === tomorrow) {
        input = `${this.$t('lang.search.dates.tomorrow')} | ${startHour} → ${endHour}`;
      } else if (start === end) {
        input = `${start} | ${startHour} → ${endHour}`;
      } else {
        input = `${start} ${startHour} → ${end} ${endHour}`;
      }
      this.inputDate = input;

      this.searchParams.input_start_date = startDate;
      this.searchParams.input_end_date = endDate;
    },

    formatDate(inputDate) {
      const date = new Date(inputDate);
      return `${date.getFullYear()}-${
        (`00${date.getMonth() + 1}`).slice(-2)}-${
        (`00${date.getDate()}`).slice(-2)} ${
        (`00${date.getHours()}`).slice(-2)}:${
        (`00${date.getMinutes()}`).slice(-2)}:${
        (`00${date.getSeconds()}`).slice(-2)}`;
    },

    async submitSearchForm(e = null) {
      if (e) {
        e.preventDefault();
      }
      this.errors = {};

      if (this.searchParams.place == null) {
        this.errors = { data_error: [this.$t('lang.search.place_error')] };
        return;
      }

      if (this.searchParams.input_end_date <= this.searchParams.input_start_date) {
        this.errors = { data_error: [this.$t('lang.search.date_error')] };
        return;
      }

      this.$store.dispatch('setSearchParams', this.searchParams);

      const { location } = this.searchParams.place.geometry;
      const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
      const lng = typeof location.lng === 'function' ? location.lng() : location.lng;
      const startDate = this.formatDate(this.searchParams.input_start_date)
        .replace(/-/g, '/')
        .replace('T', ' ');
      const endDate = this.formatDate(this.searchParams.input_end_date)
        .replace(/-/g, '/')
        .replace('T', ' ');

      this.$router.push({
        path: `/${this.$store.state.main.lang}/search`,
        query: {
          y: lat * 1000,
          x: lng * 1000,
          start_date: startDate,
          end_date: endDate,
          bags_number: 1,
          address: this.searchParams.place.formatted_address,
          open_first: 'true',
        },
      });
    },
  },
};
</script>

<style scoped>
.custom-search-input-2 i{
  font-size: .9rem;
  padding: 0 6px;
}
</style>
